import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialValues, SearchFormValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';
import { BasicInfo, DetailsTab } from './tabs';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SearchFormValues) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = (data: SearchFormValues) => {
    const combinedData = {
      ...data,
      tk: searchFieldStates.account?.uuid || '',
      ma_kh: searchFieldStates.customer?.uuid || '',
      nh_kh1: searchFieldStates.customerGroup1?.uuid || '',
      nh_kh2: searchFieldStates.customerGroup2?.uuid || '',
      nh_kh3: searchFieldStates.customerGroup3?.uuid || '',
      rg_code: searchFieldStates.region?.uuid || ''
    };
    onSearch(combinedData);
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Sổ chi tiết công nợ nhiều khách hàng'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo searchFieldStates={searchFieldStates} />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab searchFieldStates={searchFieldStates} />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
